import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { cancelQuote } from '../../services/quote'

export const CLOSE_CANCEL_QUOTE_DIALOG = 'CLOSE_CANCEL_QUOTE_DIALOG'
export const onCloseCancelQuoteDialog = makeActionCreator(CLOSE_CANCEL_QUOTE_DIALOG)

export const OPEN_CANCEL_QUOTE_DIALOG = 'OPEN_CANCEL_QUOTE_DIALOG'
export const onOpenCancelQuoteDialog = makeActionCreator(OPEN_CANCEL_QUOTE_DIALOG, 'payload')

export const CANCEL_QUOTE = 'CANCEL_QUOTE'
export const CANCEL_QUOTE_ERROR = 'CANCEL_QUOTE_ERROR'
export const CANCEL_QUOTE_SUCCESS = 'CANCEL_QUOTE_SUCCESS'
export const onCancelQuote = makeActionCreator(CANCEL_QUOTE)
export const onCancelQuoteError = makeActionCreator(CANCEL_QUOTE_ERROR, 'payload')
export const onCancelQuoteSuccess = makeActionCreator(CANCEL_QUOTE_SUCCESS)
export const onCancelQuoteThunk = payload => async dispatch => {
  dispatch(onCancelQuote())

  try {
    await cancelQuote({ quoteID: payload.quoteID, justification: payload.justification })

    return batch(() => {
      dispatch(onCancelQuoteSuccess())
      payload.callback()
    })
  } catch (error) {
    return dispatch(onCancelQuoteError({ error }))
  }
}
